import { Route } from "@angular/router";

import { pmoEntity } from "../../core/guards";
import { PageMode } from "../../shared/constants/enums";
import { createEntitiesPageGuards, manageEntitiesPageGuards, viewEntitiesPageGuards } from "./_guards";
import { EntitiesEditorComponent } from "./entities-editor/entities-editor";
import { EntitiesListComponent } from "./entities-list/entities-list";

export const ENTITIES_ROUTES: Route[] = [
  {
    path: "entities",
    canActivate: [pmoEntity, ...viewEntitiesPageGuards],
    children: [
      {
        path: "list",
        redirectTo: "",
      },
      {
        path: "",
        component: EntitiesListComponent,
        data: {
          breadcrumb: "breadcrumbs.entities",
          title: "breadcrumbs.entities",
        },
      },
      {
        path: "create",
        component: EntitiesEditorComponent,
        canActivate: [...createEntitiesPageGuards],
        data: {
          breadcrumb: "breadcrumbs.entity_module.new",
          title: "breadcrumbs.entity_module.new",
          pageMode: PageMode.create,
        },
      },
      {
        path: ":id",
        component: EntitiesEditorComponent,
        data: {
          breadcrumb: "breadcrumbs.entity_module.view",
          title: "breadcrumbs.entity_module.view",
          pageMode: PageMode.view,
        },
      },
      {
        path: "edit/:id",
        component: EntitiesEditorComponent,
        canActivate: [...manageEntitiesPageGuards],
        data: {
          breadcrumb: "breadcrumbs.entity_module.edit",
          title: "breadcrumbs.entity_module.edit",
          pageMode: PageMode.edit,
        },
      },
    ],
  },
];
